import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import NewsletterPopup from "../../components/NewsletterPopup";
import MasterclassPopup from "../../components/MassterclassPopup";
import SimpleRegistrationPopup from "../../components/MassterRegistrationPopup";
import { apiUrls, imageUrl as imgUrl, baseUrl } from "../../utils/url";
import { postRequest } from "../../utils/networking";
import { toast } from "react-toastify";
import CommonToastContainer from "../../components/CommonToastContainer";

import instructorHari from "../../assets/images/instructor_hari.png";
import shoppingCart3d from "../../assets/images/3d_shopping_cart.png";
import amazonLogo from "../../assets/images/Amazon-Logo.png";
import meeshoLogo from "../../assets/images/Meesho-Logo.png";
import flipkartLogo from "../../assets/images/Flipkart_logo.svg";

function getPath(fullPath) {
  if (!fullPath) return null;
  const normalized = fullPath.replace(/\\/g, "/");
  let path = normalized;
  if (path.startsWith('/')) {
    path = path.substring(1);
  }
  const assetsIndex = path.indexOf("assets/");
  if (assetsIndex !== -1) {
    return path.substring(assetsIndex + 7);
  }

  const asstesIndex = path.indexOf("asstes/");
  if (asstesIndex !== -1) {
    return path.substring(asstesIndex + 7);
  }
  
  if (path.includes("home/")) {
    return path.replace("home/", "");
  }
  return path;
}

const getFullImageUrl = (imagePath) => {
  if (!imagePath) return null;
  let extractedPath = getPath(imagePath);
  return `${imgUrl}/${extractedPath}`;
};

export default function Hero() {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [showCheckboxInPopup, setShowCheckboxInPopup] = useState(true);
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailText, setEmailText] = useState("");
  const [days, setDays] = useState('00');
  const [hours, setHours] = useState('00');
  const [minutes, setMinutes] = useState('00');
  const [seconds, setSeconds] = useState('00');
  const [formattedDate, setFormattedDate] = useState('');
  const [formattedTime, setFormattedTime] = useState('');
  const targetDateRef = useRef(null);
  const [isInstructorImageLoaded, setIsInstructorImageLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [webinarData, setWebinarData] = useState(null);

  const handleLoginNavigation = () => {
    navigate('/login');
  };

  // WhatsApp phone number - replace with your actual number
  const WHATSAPP_PHONE = "919876543210"; // Format: countrycode + number without +
  const WHATSAPP_MESSAGE = "Hi! I'm interested in learning more about your E-Commerce masterclass.";

  const handleWhatsAppChat = () => {
    const encodedMessage = encodeURIComponent(WHATSAPP_MESSAGE);
    const whatsappUrl = `https://wa.me/${WHATSAPP_PHONE}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  useEffect(() => {
    const updateCountdown = () => {
      if (!targetDateRef.current) return;
      
      const now = new Date();
      const diff = targetDateRef.current - now;

      if (diff <= 0) { 
        setDays('00'); 
        setHours('00'); 
        setMinutes('00'); 
        setSeconds('00');
        return;
      }

      const daysCalc = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hoursCalc = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutesCalc = Math.floor((diff / (1000 * 60)) % 60);
      const secondsCalc = Math.floor((diff / 1000) % 60);

      setDays(daysCalc.toString().padStart(2, '0'));
      setHours(hoursCalc.toString().padStart(2, '0'));
      setMinutes(minutesCalc.toString().padStart(2, '0'));
      setSeconds(secondsCalc.toString().padStart(2, '0'));
    };

    updateCountdown();
    const intervalId = setInterval(updateCountdown, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const openMasterclassPopup = (requireCheckbox = true) => {
    setShowCheckboxInPopup(requireCheckbox);
    setShowPopup(true);
    document.body.style.overflow = "hidden";
  };

  const closeMasterclassPopup = () => {
    setShowPopup(false);
    setShowCheckboxInPopup(true);
    document.body.style.overflow = "";
  };

  const openNewsletterModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setEmailSubject("");
    setEmailText("");
    setIsLoading(false);
    setShowNewsletterModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeNewsletterModal = () => {
    setEmailSubject("");
    setEmailText("");
    setIsLoading(false);
    setShowNewsletterModal(false);
    document.body.style.overflow = "";
  };

  const handleGoNext = () => {
    closeMasterclassPopup();
    setShowRegistrationModal(true);
    document.body.style.overflow = "hidden";
  };

  const openRegistrationModal = () => {
    setShowRegistrationModal(true);
    document.body.style.overflow = "hidden";
  };

  const closeRegistrationModal = () => {
    setShowRegistrationModal(false);
    document.body.style.overflow = "";
  };

  const showToast = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message);
    } else {
      toast.error(message);
    }
  };

  const handleSendNewsletter = async (e) => {
    e.preventDefault();
    
    if (!emailSubject || !emailSubject.includes('@')) {
      showToast("Please enter a valid email address", false);
      return;
    }
    
    setIsLoading(true);

    try {
      const response = await fetch(
        `${baseUrl}/ecomcourse/newsletter/createnewsletter`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: emailSubject,
          }),
        }
      );

      const data = await response.json();
      console.log("API Response:", data);

      if (response.ok) {
        const apiMessage = data.message || data.msg || data.success || data.data?.message || "Subscription successful";
        
        showToast(apiMessage, true);
        
        setTimeout(() => {
          closeNewsletterModal();
        }, 2000);
      } else {
        const errorMessage = data.message || data.error || data.msg || data.data?.message || "Subscription failed. Please try again.";
        
        showToast(errorMessage, false);
        setIsLoading(false);
      }

    } catch (error) {
      console.error("Fetch error:", error);
      showToast("Network error. Please check your connection.", false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        if (showPopup) closeMasterclassPopup();
        if (showNewsletterModal) closeNewsletterModal();
        if (showRegistrationModal) closeRegistrationModal();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [showPopup, showNewsletterModal, showRegistrationModal]);

  useEffect(() => {
    fetchWebinar();
  }, []);

  const fetchWebinar = async () => {
    try {
      const response = await postRequest(apiUrls.getcurrentwebinar);
      console.log("API", response);

      const webinar = response?.data?.[0];
      if (!webinar) return;

      setWebinarData(webinar);

      const target = new Date(webinar.asondate);
      targetDateRef.current = target;
      const dateOptions = {
        weekday: "long",
        month: "long",
        day: "numeric",
        year: "numeric",
      };  
      const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      };
      setFormattedDate(
        target.toLocaleDateString("en-US", dateOptions)
      );

      setFormattedTime(
        target.toLocaleTimeString("en-IN", timeOptions)
      );

    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  return (
    <>
      <section id="hero" className="relative min-h-screen bg-gradient-to-br from-orange-50/20 via-amber-50/30 to-white flex items-center justify-center py-10 lg:py-16 overflow-hidden">
        {/* Background shapes */}
        <div className="shape-bg">
          <div className="shape-1" style={{ background: "radial-gradient(circle at 30% 40%, #fde6d2 0%, #ffe6cc 60%, transparent 80%)" }}></div>
          <div className="shape-2" style={{ background: "radial-gradient(circle, #fdba74 0%, #fde6d2 40%, transparent 70%)" }}></div>
          <div className="shape-3" style={{ background: "#feedd9" }}></div>
          <div className="shape-4" style={{ background: "#fff3e0" }}></div>
        </div>
        <div className="decorative-blur" style={{ background: "#ffedd5", opacity: "0.4" }}></div>

        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 relative z-10 w-full">
          {/* Main Hero grid layout */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
            
            {/* Left Column (Content) */}
            <div className="lg:col-span-7 flex flex-col items-center lg:items-start text-center lg:text-left gap-6 relative">
              
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-50/80 border border-orange-200 text-[10px] sm:text-xs font-bold text-orange-600 tracking-wider uppercase animate-fade-in-up transition-all duration-300 cursor-default">
                <span className="flex items-center justify-center w-4.5 h-4.5 rounded-full bg-orange-500 text-white font-bold text-[10px] animate-pulse">
                  ✓
                </span>
                7 Figure Seller Account Audit Completed
              </div>

              {/* Title */}
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight">
                Start Your E-Commerce <br />
                <span className="text-orange-500">Journey With Us.</span>
              </h1>

              {/* Subtitle / Freebies Info */}
              <div className="hidden lg:block space-y-4 max-w-xl text-center lg:text-left">
                <p className="text-lg sm:text-xl text-gray-600 font-medium leading-relaxed">
                  We provide a free <span className="font-bold text-orange-600">Sale Price Calculator</span>,{" "}
                  <span className="font-bold text-orange-600">Ecommerce Beginner Roadmap</span>, and many other useful resources for aspiring ecommerce sellers like you!
                </p>
                <p className="text-base sm:text-lg text-gray-700 font-semibold flex items-center justify-center lg:justify-start gap-2 bg-orange-50/60 border border-orange-100/50 rounded-xl px-4 py-2.5 w-fit mx-auto lg:mx-0 shadow-sm">
                  <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse"></span>
                  To get all freebies, click the <span className="text-orange-600 font-bold underline">“Join Now”</span> button below
                </p>
              </div>

              {/* Buttons Row */}
              <div className="mt-2 flex flex-col sm:flex-row items-center gap-3">
                {/* Join Now Button (Desktop Only) */}
                <button
                  onClick={openNewsletterModal}
                  className="hidden lg:flex shimmer-btn group relative items-center justify-center gap-4 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-bold py-3.5 px-8 rounded-full transform hover:-translate-y-1 transition-all duration-300 w-fit cursor-pointer"
                >
                  <span className="tracking-wide">Join Now</span>
                  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-white text-orange-500 group-hover:translate-x-0.5 transition-transform duration-300">
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3.5" d="M9 5l7 7-7 7" />
                    </svg>
                  </span>
                </button>

                {/* WhatsApp Chat Button */}
                <button
                  onClick={handleWhatsAppChat}
                  className="group relative flex items-center justify-center gap-3 bg-white border-2 border-[#25D366] hover:bg-[#25D366] hover:text-white text-black font-bold py-3.5 px-6 rounded-full transform hover:-translate-y-1 transition-all duration-300 w-fit cursor-pointer"
                >
                  <svg className="w-5 h-5 text-[#25D366] group-hover:text-white transition-colors duration-300" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                  <span className="tracking-wide">Chat on WhatsApp</span>
                </button>

                {/* Login Button (Mobile Only) */}
                <button
                  onClick={handleLoginNavigation}
                  className="md:hidden group relative flex items-center justify-center gap-3 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-bold py-2 px-8 rounded-full transform hover:-translate-y-1 transition-all duration-300 w-fit cursor-pointer shadow-md"
                >
                  <span className="tracking-wide">Login</span>
                </button>
              </div>

              {/* Community Icons */}
              <div className="mt-8 flex flex-col items-center lg:items-start gap-3">
                <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">Our Community</span>
                <div className="flex items-center gap-3">
                  {/* WhatsApp */}
                  <a href="#" onClick={(e) => { e.preventDefault(); handleWhatsAppChat(); }} className="w-11 h-11 rounded-2xl bg-white border border-gray-100 flex items-center justify-center text-slate-700 hover:text-orange-500 hover:border-orange-100 transition-all duration-200 cursor-pointer">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                  </a>

                  {/* Instagram */}
                  <a href="https://www.instagram.com/ecom_tamil/" target="_blank" rel="noopener noreferrer" className="w-11 h-11 rounded-2xl bg-white border border-gray-100 flex items-center justify-center text-slate-700 hover:text-orange-500 hover:border-orange-100 transition-all duration-200">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.266.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </a>
                  {/* Facebook */}
                  <a href="https://www.facebook.com/profile.php?id=61579631565605" target="_blank" rel="noopener noreferrer" className="w-11 h-11 rounded-2xl bg-white border border-gray-100 flex items-center justify-center text-slate-700 hover:text-orange-500 hover:border-orange-100 transition-all duration-200">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                    </svg>
                  </a>
                  {/* YouTube */}
                  <a href="https://www.youtube.com/@ecom_tamil" target="_blank" rel="noopener noreferrer" className="w-11 h-11 rounded-2xl bg-white border border-gray-100 flex items-center justify-center text-slate-700 hover:text-orange-500 hover:border-orange-100 transition-all duration-200">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                    </svg>
                  </a>
                </div>
              </div>

              {/* Large 3D Shopping Cart Asset */}
              <img 
                src={shoppingCart3d} 
                alt="3D Shopping Cart" 
                className="absolute -bottom-16 left-[70%] w-[350px] h-[350px] object-contain pointer-events-none z-0 hidden lg:block animate-float-delayed" 
              />
            </div>

            {/* Right Column (Instructor Card & Masterclass Card) */}
            <div className="lg:col-span-5 flex flex-col sm:flex-row lg:flex-col items-center justify-center gap-6 w-full z-10 lg:pl-10">
              
              {/* Instructor Card */}
              <div className="relative rounded-3xl overflow-hidden border border-orange-100 bg-white max-w-[280px] w-full aspect-square relative shrink-0">
                {webinarData?.mentorprofileurl && (
                  <>
                    {!isInstructorImageLoaded && (
                      <div className="absolute inset-0 bg-gray-100 animate-pulse flex items-center justify-center z-0">
                        <svg className="w-8 h-8 text-orange-400 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </div>
                    )}
                    <img 
                      src={getFullImageUrl(webinarData.mentorprofileurl)} 
                      alt={`Instructor ${webinarData?.mentorname || ""}`}
                      className={`w-full h-full object-cover relative z-10 transition-opacity duration-300 ${isInstructorImageLoaded ? 'opacity-100' : 'opacity-0'}`}
                      onLoad={() => setIsInstructorImageLoaded(true)}
                    />
                  </>
                )}
                
                {/* Overlay details */}
                <div className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-black/80 via-black/40 to-transparent">
                  <p className="text-[10px] font-bold text-orange-500 uppercase tracking-widest mb-0.5">Instructor</p>
                  <h3 className="text-base font-bold text-white leading-tight">{webinarData?.mentorname || ""}</h3>
                  <p className="text-xs text-gray-300">{webinarData?.mentorrole || ""}</p>
                </div>

                {/* Orange Badge with White Star */}
                <div className="absolute bottom-4 right-4 w-9 h-9 rounded-xl bg-orange-500 flex items-center justify-center text-white">
                  <svg className="w-5 h-5 fill-current" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                </div>
              </div>

              {/* Masterclass details card */}
              <div className="bg-white p-5 sm:p-6 rounded-3xl border border-orange-50 w-full max-w-[360px] flex flex-col gap-4">
                
                {/* Title and Date Row */}
                <div>
                  <h3 className="font-bold text-gray-900 text-base sm:text-lg mb-1 leading-snug">
                    {webinarData?.webinarname || "Future of E-commerce"}
                  </h3>
                  
                  <div className="flex items-center justify-between mt-2.5 text-xs">
                    <span className="font-bold text-amber-700">{formattedDate || "Wednesday, June 3, 2026"}</span>
                    <span className="flex items-center gap-1 font-semibold text-gray-400">
                      <svg className="w-3.5 h-3.5 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="9" />
                        <path d="M12 6v6l4 2" />
                      </svg>
                      {formattedTime || "02:02 pm"}
                    </span>
                  </div>
                </div>

                {/* Countdown Timer Block */}
                <div className="bg-orange-50/40 rounded-2xl p-3 sm:p-4 border border-orange-100/50">
                  <div className="grid grid-cols-4 gap-2 text-center">
                    {/* Days */}
                    <div className="flex flex-col items-center">
                      <div className="w-full bg-white rounded-xl py-2 border border-orange-100/40 flex items-center justify-center min-h-[44px]">
                        <span className="text-xl font-extrabold text-orange-600 leading-none">{days}</span>
                      </div>
                      <span className="text-[9px] font-bold text-gray-400 uppercase mt-1.5 tracking-wider">DAYS</span>
                    </div>
                    {/* Hours */}
                    <div className="flex flex-col items-center">
                      <div className="w-full bg-white rounded-xl py-2 border border-orange-100/40 flex items-center justify-center min-h-[44px]">
                        <span className="text-xl font-extrabold text-orange-600 leading-none">{hours}</span>
                      </div>
                      <span className="text-[9px] font-bold text-gray-400 uppercase mt-1.5 tracking-wider">HRS</span>
                    </div>
                    {/* Minutes */}
                    <div className="flex flex-col items-center">
                      <div className="w-full bg-white rounded-xl py-2 border border-orange-100/40 flex items-center justify-center min-h-[44px]">
                        <span className="text-xl font-extrabold text-orange-600 leading-none">{minutes}</span>
                      </div>
                      <span className="text-[9px] font-bold text-gray-400 uppercase mt-1.5 tracking-wider">MINS</span>
                    </div>
                    {/* Seconds */}
                    <div className="flex flex-col items-center">
                      <div className="w-full bg-white rounded-xl py-2 border border-orange-100/40 flex items-center justify-center min-h-[44px]">
                        <span className="text-xl font-extrabold text-orange-600 leading-none">{seconds}</span>
                      </div>
                      <span className="text-[9px] font-bold text-gray-400 uppercase mt-1.5 tracking-wider">SECS</span>
                    </div>
                  </div>
                </div>

                {/* Primary Orange Gradient Button */}
                <button
                  onClick={() => openMasterclassPopup(true)}
                  className="w-full bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white text-xs sm:text-sm font-bold py-3.5 px-4 rounded-2xl transition-all duration-300 transform hover:-translate-y-0.5 cursor-pointer flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4 text-white shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  Check Master Class Details
                </button>

                {/* Secondary Border/Translucent Button */}
                <button
                  onClick={openRegistrationModal}
                  disabled={days === '00' && hours === '00' && minutes === '00' && seconds === '00'}
                  className={`w-full bg-white border border-gray-100 hover:border-orange-200 text-gray-700 hover:text-orange-500 text-xs sm:text-sm font-bold py-3.5 px-4 rounded-2xl transition-all duration-300 flex items-center justify-between ${
                    (days === '00' && hours === '00' && minutes === '00' && seconds === '00')
                      ? 'opacity-50 !cursor-not-allowed grayscale' 
                      : 'hover:-translate-y-0.5 cursor-pointer'
                  }`}>
                  <span className="mx-auto pl-4">Join The Masterclass Now</span>
                  <svg className="w-4 h-4 text-gray-400 shrink-0" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                  </svg>
                </button>

                {/* Join Now Section (Mobile Only) */}
                <div className="lg:hidden bg-white rounded-2xl p-5 mt-4 text-center border border-gray-200 shadow-sm">
                  <p className="text-xs sm:text-sm text-gray-800 mb-3 leading-relaxed">
                    We provides free <span className="font-bold text-gray-900">Sale Price Calculator</span>, <span className="font-bold text-gray-900">Ecommerce Beginner Roadmap</span>, and many usefull data to aspiring ecommerce sellers like you!
                  </p>
                  <p className="text-xs sm:text-sm text-gray-800 mb-4">
                    To get all freebies, Click "join now" Button
                  </p>
                  <button
                    onClick={openNewsletterModal}
                    className="shimmer-btn group relative flex items-center justify-center gap-3 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white text-xs sm:text-sm font-bold py-3.5 px-8 rounded-full transform hover:-translate-y-1 transition-all duration-300 w-fit mx-auto cursor-pointer"
                  >
                    <span className="tracking-wide">Join Now</span>
                    <span className="flex items-center justify-center w-6 h-6 rounded-full bg-white text-orange-500 group-hover:translate-x-0.5 transition-transform duration-300">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                      </svg>
                    </span>
                  </button>
                </div>
              </div>

            </div>
          </div>

          {/* Bottom Features Banner */}
          <div className="w-full mt-16 bg-white rounded-3xl border border-gray-50 p-6 sm:p-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            
            {/* Feature 1 */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-2xl bg-orange-50 flex items-center justify-center text-orange-500 shrink-0 border border-orange-100/50">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l9-5-9-5-9 5 9 5z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-sm mb-1">Expert Guidance</h4>
                <p className="text-xs text-gray-500 leading-relaxed">Learn from experienced e-commerce professionals.</p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-2xl bg-orange-50 flex items-center justify-center text-orange-500 shrink-0 border border-orange-100/50">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-sm mb-1">Proven Strategies</h4>
                <p className="text-xs text-gray-500 leading-relaxed">Real-world strategies to scale your business.</p>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-2xl bg-orange-50 flex items-center justify-center text-orange-500 shrink-0 border border-orange-100/50">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-sm mb-1">Community Support</h4>
                <p className="text-xs text-gray-500 leading-relaxed">Join a growing community of e-commerce learners.</p>
              </div>
            </div>

            {/* Feature 4 */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-2xl bg-orange-50 flex items-center justify-center text-orange-500 shrink-0 border border-orange-100/50">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <div>
                <h4 className="font-bold text-gray-900 text-sm mb-1">Lifetime Access</h4>
                <p className="text-xs text-gray-500 leading-relaxed">Access resources and updates for lifetime.</p>
              </div>
            </div>

          </div>

          {/* Trust & Stats Section */}
          <div className="w-full mt-16 bg-white/80 backdrop-blur-sm rounded-3xl border border-orange-100/50 p-8 sm:p-12">
            
            {/* Stats Grid */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
              {/* Stat 1 */}
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-extrabold text-orange-500">42K+</div>
                <p className="text-sm text-gray-600 mt-1 font-medium">Instagram Followers</p>
              </div>
              
              {/* Stat 2 */}
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-extrabold text-orange-500">1200+</div>
                <p className="text-sm text-gray-600 mt-1 font-medium">Students Trained</p>
              </div>
              
              {/* Stat 3 */}
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-extrabold text-orange-500">150+</div>
                <p className="text-sm text-gray-600 mt-1 font-medium">Brands Served</p>
              </div>
              
              {/* Stat 4 */}
              <div className="text-center">
                <div className="text-3xl md:text-4xl font-extrabold text-orange-500">10Cr+</div>
                <p className="text-sm text-gray-600 mt-1 font-medium">Revenue Generated</p>
              </div>
            </div>

            {/* Divider */}
            <div className="w-full h-px bg-gradient-to-r from-transparent via-orange-200 to-transparent my-8"></div>

            {/* Trust Text */}
            <div className="text-center">
              <p className="text-sm md:text-base font-semibold text-gray-500 tracking-wider uppercase">
                TRUSTED BY ASPIRING ENTREPRENEURS ACROSS TAMIL NADU
              </p>
            </div>

            {/* Brand Logos with Images - Consistent sizing */}
            <div className="flex flex-wrap items-center justify-center gap-10 md:gap-14 mt-4">
              {/* Amazon */}
              <img 
                src={amazonLogo} 
                alt="Amazon" 
                className="h-7 md:h-7 object-contain opacity-70 hover:opacity-100 hover:scale-105 transition-all duration-300 cursor-default"
              />
              
              {/* Flipkart */}
              <img 
                src={flipkartLogo} 
                alt="Flipkart" 
                className="h-30 md:h-30 object-contain opacity-70 hover:opacity-100 hover:scale-105 transition-all duration-300 cursor-default"
              />
              
              {/* Meesho */}
              <img 
                src={meeshoLogo} 
                alt="Meesho" 
                className="h-7 md:h-7 object-contain opacity-70 hover:opacity-100 hover:scale-105 transition-all duration-300 cursor-default"
              />
            </div>

          </div>

        </div>
      </section>

      <MasterclassPopup 
        isOpen={showPopup}
        onClose={closeMasterclassPopup}
        onGoNext={handleGoNext}
        webinarDescription={webinarData?.webinardescription}
        showCheckbox={showCheckboxInPopup}
      />

      {showNewsletterModal && (
        <div 
          className="fixed inset-0 bg-gray-900/60 backdrop-blur-md flex items-center justify-center z-50 p-4"
          onClick={(e) => {
            if (e?.target === e?.currentTarget) {
              closeNewsletterModal();
            }
          }}
        >
          <div className="bg-white rounded-2xl max-w-md w-full mx-auto relative ">
            <button 
              onClick={closeNewsletterModal} 
              className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 text-2xl font-light z-10 transition-colors"
            >
              &times;
            </button>
            
            <div className="p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6 text-center">Free Subscription</h2>
              
              <form onSubmit={handleSendNewsletter} className="space-y-5">
                <div>
                  <label htmlFor="emailSubject" className="block text-sm font-semibold text-gray-700 mb-2">
                    Email
                  </label>
                  <input 
                    type="email" 
                    id="emailSubject"
                    value={emailSubject}
                    onChange={(e) => setEmailSubject(e?.target?.value)}
                    placeholder="Enter your email"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                    required
                    disabled={isLoading}
                  />
                </div>
              
                <button 
                  type="submit"
                  disabled={isLoading}
                  className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold py-3 rounded-lg transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-70 disabled:cursor-not-allowed disabled:hover:transform-none flex items-center justify-center gap-2"
                >
                  {isLoading ? (
                    <>
                      <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Loading...
                    </>
                  ) : (
                    "Join Now"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
      <CommonToastContainer />

      <SimpleRegistrationPopup 
        isOpen={showRegistrationModal}
        onClose={closeRegistrationModal}
        webinarid={webinarData?.webinarid || webinarData?.id || 1}
        webinarPrice={webinarData?.price || ""}
        webregid={1}
        onSuccess={showToast}
        showPrice={false}
      />
    </>
  );
}